/**
 * Shivcrafts Analytics — zero-dep dataLayer module.
 * - Ensures window.dataLayer exists and normalizes pushes
 * - Auto-wires [data-shv-event] elements
 * - Emits page_view on load with product/cart context when available
 * - Integrates with Microsoft Clarity when window.clarity is present
 * - Small by design: target <3KB minified
 *
 * Public API:
 *   window.shvAnalytics.track(event, props?)
 *   window.shvAnalytics.identify(traits)
 *   window.shvAnalytics.onReady(cb)
 */
(function () {
  if (window.shvAnalytics) return;

  var queue = [];
  var ready = false;
  var DL = (window.dataLayer = window.dataLayer || []);

  function now() {
    return Date.now();
  }

  function safePush(payload) {
    try {
      DL.push(payload);
    } catch (_) {}
    if (window.clarity && typeof window.clarity === 'function') {
      try {
        window.clarity('event', payload.event);
        if (payload.product_handle) window.clarity('set', 'product', payload.product_handle);
      } catch (_) {}
    }
  }

  function track(event, props) {
    if (!event) return;
    var payload = Object.assign({ event: event, timestamp: now() }, props || {});
    safePush(payload);
  }

  function identify(traits) {
    safePush(Object.assign({ event: 'identify', timestamp: now() }, traits || {}));
  }

  function onReady(cb) {
    if (typeof cb !== 'function') return;
    if (ready) return cb();
    queue.push(cb);
  }

  function flushReady() {
    ready = true;
    while (queue.length) {
      try { queue.shift()(); } catch (_) {}
    }
  }

  // Auto-wire click tracking for [data-shv-event].
  function handleClick(e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-shv-event]') : null;
    if (!el) return;
    var name = el.getAttribute('data-shv-event');
    if (!name) return;
    var props = {};
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name.indexOf('data-shv-') === 0 && a.name !== 'data-shv-event') {
        props[a.name.replace('data-shv-', '')] = a.value;
      }
    }
    track(name, props);
  }

  // Page-view with best-effort context.
  function firePageView() {
    var ctx = { path: location.pathname, referrer: document.referrer || '' };
    var pageType = document.body && document.body.dataset ? document.body.dataset.pageType : '';
    if (pageType) ctx.page_type = pageType;
    // Shopify theme exposes ShopifyAnalytics on most themes — piggyback safely.
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.product) {
        ctx.product_id = meta.product.id;
        ctx.product_type = meta.product.type;
        ctx.product_vendor = meta.product.vendor;
      }
      if (meta && meta.page) {
        ctx.page_resource_type = meta.page.resourceType;
      }
    } catch (_) {}
    track('page_view', ctx);
  }

  window.shvAnalytics = {
    track: track,
    identify: identify,
    onReady: onReady
  };

  document.addEventListener('click', handleClick, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      firePageView();
      flushReady();
    });
  } else {
    firePageView();
    flushReady();
  }
})();
